export default {
  tags: {
    default: 'Predefinito',
    visible_to: 'Visibile a',
    not_visible_to: 'Non visibile a',
  },
  labels: {
    inclusive: 'Inclusivo',
    exclusive: 'Esclusivo',
    public: 'Pubblico',
  },
  buttons: {
    edit: 'Modifica',
    delete: 'Elimina',
  },
};
